import React, { useState, useEffect} from 'react'
import styled from 'styled-components';
import Avatar from '../Avatar'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather';

import bot1 from '../../../assets/avatars/bot-1.svg'
import bot2 from '../../../assets/avatars/bot-2.svg'
import bot3 from '../../../assets/avatars/bot-3.svg'
import bot4 from '../../../assets/avatars/bot-4.svg'
import bot5 from '../../../assets/avatars/bot-5.svg'
import bot6 from '../../../assets/avatars/bot-6.svg'
import bot7 from '../../../assets/avatars/bot-7.svg'
import bot8 from '../../../assets/avatars/bot-8.svg'
import bot9 from '../../../assets/avatars/bot-9.svg'
import bot10 from '../../../assets/avatars/bot-10.svg'
import bot11 from '../../../assets/avatars/bot-11.svg'
import bot12 from '../../../assets/avatars/bot-12.svg'
import bot13 from '../../../assets/avatars/bot-13.svg'
import bot14 from '../../../assets/avatars/bot-14.svg'
import bot15 from '../../../assets/avatars/bot-15.svg'
import bot16 from '../../../assets/avatars/bot-16.svg'
import bot17 from '../../../assets/avatars/bot-17.svg'
import bot18 from '../../../assets/avatars/bot-18.svg'
import bot6_1 from '../../../assets/avatars/bot-6-1.svg'
import bot17_1 from '../../../assets/avatars/bot-17-1.svg'
import bot18_1 from '../../../assets/avatars/bot-18-1.svg'



export default function AvatarSelection({ handleAvatarSelection, activeAvatar, isDisabled}) {
  //const items= [bot1,bot2,bot3,bot4,bot5,bot6,bot7,bot8,bot9,bot10,bot11,bot12,bot13,bot14,bot15,bot16,bot17,bot18];

  const items = [
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-1.svg?alt=media&token=1794cd5e-58ea-4c84-88be-1434ad8deeb2', image: bot1 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-2.svg?alt=media&token=ba6e37c5-6ad2-4700-94f2-4afaadbe1012', image: bot2 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-3.svg?alt=media&token=58f51701-8369-44f7-b0bc-856bc1930dbb', image: bot3 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-4.svg?alt=media&token=06d96a30-11b8-4744-a6b3-53de319f7a1d', image: bot4 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-5.svg?alt=media&token=b8328754-a458-4210-ad5a-55954c188c76', image: bot5 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-6.svg?alt=media&token=00a7a0a6-cf41-44f9-8de7-3284f7b552e9', image: bot6 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-7.svg?alt=media&token=13d9e75f-4095-411a-8230-165a56aa67c3', image: bot7 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-8.svg?alt=media&token=1a59d19c-f527-4754-9e32-981742716415', image: bot8 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-9.svg?alt=media&token=9adbb1df-92c0-45b5-8458-caf9d8990553', image: bot9 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-10.svg?alt=media&token=2022f168-2f9b-4bba-af62-0cdb27414838', image: bot10 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-11.svg?alt=media&token=3095b84e-f61c-42ff-925a-829a91511267', image: bot11 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-12.svg?alt=media&token=946a42c1-c55d-4bea-b037-1bd7e2b0b9ae', image: bot12 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-13.svg?alt=media&token=77ee9735-59c8-4ca6-8908-bbc6ac0159e9', image: bot13 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-14.svg?alt=media&token=901d37a8-4d65-40e3-8264-e2d174a0ad01', image: bot14 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-15.svg?alt=media&token=3bb0cd43-c067-43ff-aac9-80215363f18f', image: bot15 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-16.svg?alt=media&token=b2b58fd0-3497-4f5d-8979-60c2b9559b4c', image: bot16 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-17.svg?alt=media&token=da109233-1229-44cc-8a57-1d4b958ed0ae', image: bot17 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-18.svg?alt=media&token=b6f78c71-6591-49ba-bc6e-9262d8e51840', image: bot18 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-6-1.svg?alt=media&token=1447ecbc-2020-46f4-ae35-f896879a4fd9', image: bot6_1 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-17-1.svg?alt=media&token=711c5f52-b7dc-4874-9e1d-6637db325f2b', image: bot17_1 },
    { url: 'https://firebasestorage.googleapis.com/v0/b/aprendetic-5c640.appspot.com/o/bots%2Fbot-18-1.svg?alt=media&token=a7dcca66-0d67-430c-86de-ba0bf6a846fa', image: bot18_1 }
  ]


  const [activeIndex, setActiveIndex] = useState(0);

  setTimeout(() => handleAvatarSelection(items[activeIndex].url), 0);

  const next = (e) => {
    e.preventDefault();
    const nexIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nexIndex);
    handleAvatarSelection(items[activeIndex].url);
  }
  const previous = (e) => {
    e.preventDefault();
    const nexIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nexIndex);
    handleAvatarSelection(items[activeIndex].url);
  }

  useEffect(() => {
    items.forEach((item, index)=>{
      if(item.url==activeAvatar){
        setActiveIndex(index);
        handleAvatarSelection(items[activeIndex].url);
      }
    })
  }, [activeAvatar])
  
  return (
    <Container>
      <Title>Elige tu avatar</Title>
      <Wrapper >
        <Button onClick={previous} disabled={isDisabled} ><ArrowLeftCircle/></Button>
        <Avatar src={items[activeIndex].image} width='80px' />
        <Button onClick={next} disabled={isDisabled}><ArrowRightCircle /></Button>
      </Wrapper>
    </Container>
  )
}

const Container = styled.div`
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    div{
      margin: 0px 32px;
    }
`;

const Title = styled.span`
    margin: 16px 0;
`;



const Button = styled.button`
    cursor: pointer;
    background-color: transparent;
    border: none;
    margin: 24px;
    
    &:active {
        position: relative;
        top: 2px
    }

    svg{
      color: var(--color-morado-oscuro)
    }
  
    :disabled{
        opacity:0.5;
        cursor: not-allowed;
        color:red;
    }
`;



